<template>
    <div class="card">
        <div class="card-body">
            <div v-if="step == 1">
                <p>Этот простой и быстрый инструмент поможет Вам создать приложение для Вашего бизнеса или Вашего клиента.</p>
                <p>Создание приложения с готовым решением займет всего несколько минут и пару кликов. Пройдите несколько шагов и для Вас будет <span @click="test++">создан</span> шаблонный кейс со всем необходимым функционалом. После создания Вы в любое время сможете отредактировать его под себя, как Вам захочется.</p>
                <div v-if="errors.length">
                    <p v-for="error in errors" class="text-danger">{{ error }}</p>
                </div>
                <button v-if="type" @click="step1" class="btn btn-success">Далее</button>
                <div class="row">
                    <div class="mt-3 mb-4 col-md-6">
                        <label for="name">Название кейса</label>
                        <input type="text" class="form-control name" v-model="name">
                    </div>
                </div>
                <h4>Кейс</h4>
                <p>Выберите кейс, который подходит под Ваш род деятельности или желаемое приложение:</p>
                <div class="row">
                    <div class="col-md-6" style="padding-right: 50px">
                        <h6>Торговля</h6>
                        <ul class="nav nav-pills">
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 1}" href="javascript:;" @click="type = 1">Интернет-магазин</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 2}" href="javascript:;" @click="type = 2">Доставка еды</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 23}" href="javascript:;" @click="type = 23">Магазин одежды</a>
                          </li>
                        </ul>
                        <h6>Компании и сервисы</h6>
                        <ul class="nav nav-pills">
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 5}" href="javascript:;" @click="type = 5">Салон красоты</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 24}" href="javascript:;" @click="type = 24">Отель</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 22}" href="javascript:;" @click="type = 22">Клиника</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 19}" href="javascript:;" @click="type = 19">Стоматология</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 20}" href="javascript:;" @click="type = 20">Ресторан</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 21}" href="javascript:;" @click="type = 21">Автосервис</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 6}" href="javascript:;" @click="type = 6">Мягкая мебель на заказ</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 7}" href="javascript:;" @click="type = 7">Кухни на заказ</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 17}" href="javascript:;" @click="type = 17">Установка окон</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 18}" href="javascript:;" @click="type = 18">Организация мероприятий</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 9}" href="javascript:;" @click="type = 9">Другое</a>
                          </li>
                        </ul>
                        <h6>Частные услуги</h6>
                        <ul class="nav nav-pills">
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 3}" href="javascript:;" @click="type = 3">Маникюр</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 10}" href="javascript:;" @click="type = 10">Стилист</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 4}" href="javascript:;" @click="type = 4">Ремонт квартир</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 11}" href="javascript:;" @click="type = 11">
                            Компьютерный мастер
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 12}" href="javascript:;" @click="type = 12">
                            Юридические услуги
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 13}" href="javascript:;" @click="type = 13">
                            Психотерапевт
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 14}" href="javascript:;" @click="type = 14">
                            Репетитор
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 15}" href="javascript:;" @click="type = 15">
                            Массажист
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 16}" href="javascript:;" @click="type = 16">
                            Аниматор
                            </a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link case-item" :class="{'active' : type == 8}" href="javascript:;" @click="type = 8">Другое</a>
                          </li>
                        </ul>
                    </div>
                    <div class="col-md-6" v-if="type > 0">
                        <h4>{{ cases['type_' + type].name }}</h4>
                        <div v-if="cases['type_' + type].example">
                            <p>
                                <strong>Пример приложения:</strong> {{ cases['type_' + type].example.name }}<br />
                                <a :href="type != 3 || type != 4 || type != 5 || type != 6 || type != 7 ? 'https://gmaproject.ru/apps/' + cases['type_' + type].example.android + '.apk' : 'https://play.google.com/store/apps/details?id=org.gma.' + cases['type_' + type].example.android" target="_blank">Скачать на Android</a><br/>
                                <a :href="'/run_ios_examples/' + cases['type_' + type].example.ios" target="_blank">Запустить на iOS</a>
                            </p>
                        </div>
                        <p>В этом кейсе:</p>
                        <ul style="padding-left: 20px;">
                            <li>Создание макета приложения, который можно запустить на Android через apk-файл и на iOS через приложение <a href="https://apps.apple.com/ru/app/givemeapp-launcher/id6557082806" target="_blank">GiveMeApp Launcher</a>.</li>
                            <li>Созданный макет приложения, после этого, можно будет отредактировать, как Вам захочется, и довести до готового приложения, отвечающего Вашим требованиям.</li>
                            <template v-if="cases['type_' + type].blocks.indexOf(1) >= 0">
                                <li>Приложение будет иметь каталоги с шаблонными товарами. Данные каталоги можно будет отредактировать, изменив имеющиеся или добавив свои товары.</li>
                                <li>Отправленные клиентами заказы могут приходить в Telegram, на e-mail и сохраняться в разделе Заказы в Вашем личном кабинете сайта, где Вы сможете управлять заказами и клиентами.</li>
                                <li>Вы сможете настроить оформление каталогов и корзины, валюту, форму заказа, условия заказа и доставки, онлайн-оплату в Вашем личном кабинете сайта.</li>
                                <li>Вы сможете добавить и настроить на разные условия промокоды со скидками и подарками.</li>
                                <li>Вы сможете включить и настроить систему баллов для Ваших клиентов.</li>
                                <li>Вы сможете распределить отправку заказов по разным контактным данным, в зависимости от товаров в заказе, если планируете делать маркетплейс, через раздел <a href="/shop/cart" target="_blank">Дополнительные корзины</a>.</li>
                                <li>Вы получаете возможность отправлять клиентам push-уведомления через  <a href="/notifications" target="_blank">наш интерфейс отправки</a>. <span v-if="!check_trial"><strong>Эта функция не активна в рамках пробного периода.</strong></span></li>
                                <li>Все изменения в приложении и каталогах товаров будут подгружаться пользователям онлайн без необходимости обновлять приложение.</li>
                            </template>
                            <template v-if="cases['type_' + type].blocks.indexOf(2) >= 0">
                                <li>Приложение будет иметь формы заявки или записи на услугу с возможностью выбора услуги, сотрудника, даты и времени записи. Формы имеют гибкие настройки на любой случай.</li>
                                <li>Отправленные клиентами заявки могут приходить в Telegram, на e-mail и сохраняться в разделе Записи с форм в Вашем личном кабинете сайта, где Вы сможете управлять заявками.</li>
                                <li>Приложение будет иметь список с шаблонными услугами. Данный список можно будет отредактировать, изменив имеющиеся или добавив свои услуги.</li>
                            </template>
                            <template v-if="cases['type_' + type].blocks.indexOf(4) >= 0">
                                <li>Приложение будет иметь форму бронирования стола с возможностью выбора даты и времени бронирования. Форма имеют гибкие настройки на любой случай.</li>
                                <li>Отправленные клиентами заявки могут приходить в Telegram, на e-mail и сохраняться в разделе Записи с форм в Вашем личном кабинете сайта, где Вы сможете управлять заявками.</li>
                                <li>Приложение будет иметь меню с шаблонными блюдами. Данное меню можно будет отредактировать, изменив имеющиеся или добавив свои блюда или услуги.</li>
                            </template>
                            <template v-if="cases['type_' + type].blocks.indexOf(5) >= 0">
                                <li>Приложение будет иметь форму бронирования номера с возможностью выбора даты заезда и выезда. Форма имеют гибкие настройки на любой случай.</li>
                                <li>Отправленные клиентами заявки могут приходить в Telegram, на e-mail и сохраняться в разделе Записи с форм в Вашем личном кабинете сайта, где Вы сможете управлять заявками.</li>
                                <li>Приложение будет иметь списое шаблонных номеров. Данный списое можно будет отредактировать, изменив имеющиеся или добавив свои номера или услуги.</li>
                            </template>
                            <template v-if="cases['type_' + type].blocks.indexOf(3) >= 0">
                                <li>Приложение будет иметь список с шаблонными сотрудниками. Данный список можно будет отредактировать, изменив имеющихся или добавив своих сотрудников.</li>
                            </template>
                            <li>Вы сможете опубликовать приложение в Google Play и App Store.</li>
                            <li>Стоимость полного пакета функций: <span v-if="auth != 1 || check_services == 2 || check_services == 3"><span v-if="!check_trial"><strong>бесплатно 7 дней</strong>, далее {{ cases['type_' + type].price }} рублей в месяц</span><span v-else><strong>{{ cases['type_' + type].price }} рублей в месяц</strong></span></span><span v-else><strong>функции уже подключены</strong></span></li>
                        </ul>
                        <template v-if="cases['type_' + type].imgs">
                            <div class="row">
                                <div
                                  v-for="(src, i) in cases['type_' + type].imgs"
                                  :key="i"
                                  @click="() => showImg(i)"
                                  class="col-sm-4"
                                >
                                  <img :src="src" class="col-sm-12 mb-4" />
                                </div>
                            </div>
                        </template>
                        <vue-easy-lightbox
                            :visible="visible"
                            :imgs="cases['type_' + type].imgs"
                            :index="img_index"
                            @hide="handleHide"
                        ></vue-easy-lightbox>
                    </div>
                </div>
                <div v-if="errors.length">
                    <p v-for="error in errors" class="text-danger">{{ error }}</p>
                </div>
                <button v-if="type" @click="step1" class="btn btn-success">Далее</button>
            </div>
            <div v-if="step == 2">
                <div v-if="auth == 1">
                    <template v-if="check_projects == 1">
                        <h4>Дополнительные функции</h4>
                        <p>Вы можете подключить приложение к тарифу Pro, чтобы получить следующие функции:</p>
                        <ul>
                            <li>Отправка push-уведомлений в приложение  через  <a href="/notifications" target="_blank">наш интерфейс отправки</a>.</li>
                            <li>Все изменения в приложении подгружаются сразу, без необходимости устанавливать новую версию.</li>
                            <li>Запуск приложения на iOS через <a href="https://apps.apple.com/ru/app/givemeapp-tools/id6754886478" target="_blank">GiveMeApp Tools</a> по любому полученному коду на любом устройстве.</li>
                            <li>Стоимость тарифа Pro: <strong>390 рублей в месяц</strong></li>
                        </ul>
                        <div class="form-group">
                            <input type="checkbox" v-model="pro" value="1" id="pro"> <label for="pro">Продключить тариф Pro</label>
                        </div>
                    </template>
                    <template v-if="check_projects == 2">
                        <p>К сожалению, на одном аккаунте можно создать до 10 приложений. В связи с этим, создание нового кейса на данный момент невозможно. На одном аккаунте можно добавить до 10 приложений. Удалите ненужные приложения в разделе <a href="/projects" target="_blank">Приложения</a> или зарегистрируйте новый аккаунт для новых приложений.</p>
                    </template>
                </div>
                <div v-else>
                    <p>Чтобы продолжить <a href="/login" target="_blank">авторизуйтесь</a> или <a href="/register" target="_blank">зарегистрируйтесь</a>, если у Вас еще нет аккаунта на сайте. После этого вернитесь на эту страницу.</p>
                </div>
                <button @click="step--" class="btn btn-default border me-2">Назад</button>
                <button v-if="auth == 1 && check_projects == 1" @click="step2" class="btn btn-success">Далее</button>
            </div>
            <div v-if="step == 3">
                <div v-if="auth == 1">
                    <template v-if="check_projects == 1">
                        <template v-if="price > 0">
                            <template v-if="check_services == 2 || check_services == 3">
                                <template v-if="type == 1 || type == 2 || type == 23">
                                    <p>Для активации всех необходимых функций Ваш аккаунт будет подключен на <strong>Максимальный тариф</strong> создания интернет-магазинов, которым Вы сможете пользоваться на Ваше усмотрение.</p>
                                </template>
                                <template v-else>
                                    <p>Для активации всех необходимых функций будет подключен пункт <strong>Улучшение функций форм</strong> в разделе <a href="/tarif" target="_blank">Настроить функции</a>.</p>
                                </template>
                                <p>Стоимость подключения - {{ cases['type_' + type].price }} рублей.</p>
                                <p><strong>Обратите внимание!</strong> Сумма оплачивается один раз сроком на месяц. При создании последующих кейсов, которые требуют тот же набор функций, оплата в течении этого месяца не потребуется.</p>
                            </template>
                            <template v-if="check_services == 1">
                                <p>У Вас уже подключены все необходимые функции для создания кейса.</p>
                            </template>
                            <template v-if="pro && !trial">
                                <p>Дополнительно приложение подключается к тарифу Pro. Стоимость - 390 рублей в месяц.</p>
                            </template>
                            <p>Итоговая сумма оплаты для создания кейса - {{ price - (trial && pro ? 390 : 0) }} рублей.</p>
                            <template v-if="trial">
                                <p>Функции будут подключены бесплатно на 7 дней.</p>
                            </template>
                            <template v-else>
                                <template v-if="check_balance == 1">
                                    <div v-if="add_balance_in_process == 2">
                                        <p>Вы успешно пополнили баланс.</p>
                                    </div>
                                    <div v-else>
                                        <p>Сумма будет списана с баланса.</p>
                                    </div>
                                    <p>Для создания кейса нажмите кнопку <strong>Создать кейс</strong>.</p>
                                </template>
                                <template v-if="check_balance == 2">
                                    <div v-if="add_balance_in_process == 2">
                                        <p>Вы успешно пополнили баланс.</p>
                                    </div>
                                    <p>Средств на балансе не хватает для оплаты. Чтобы создать кейс, пожалуйста, пополните баланс.</p>
                                    <div class="row">
                                        <div class="col-md-6">
                                            <div class="portlet portlet-boxed">
                                                <div class="portlet-header">
                                                    <h4 class="portlet-title">
                                                        <u>Пополнение баланса</u>
                                                    </h4>
                                                </div> <!-- /.portlet-header -->

                                                <div class="portlet-body">
                                                    <p>Пополнение возможно с российских банковских карт. Если Вам недоступен этот способ пополнения, напишите в <a href="/support">Службу поддержки</a>.</p>
                                                    <div class="row">
                                                        <div class="col-md-6">
                                                            <div v-show="add_balance_in_process != 1" class="amount_block2 form-group">
                                                                <label class="control-label">Сумма</label>
                                                                <input type="number" name="amount" v-model="add_balance_amount" class="form-control amount_value2" min = 0 step = 10 />
                                                                <br />
                                                                <button @click="add_balance" class="btn btn-success send_pay">Пополнить</button>
                                                            </div>
                                                            <div v-show="add_balance_in_process == 1" id="payment-form"></div>
                                                        </div>
                                                    </div>  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                                <template v-if="!check_trial && !trial">
                                    <div class="mb-3">
                                        <button @click="trial = 1" class="btn btn-info text-white">Активировать пробный период на 7 дней</button>
                                        <p v-if="pro"><strong>Обратите внимание!</strong> При активации пробного периода Тариф Pro не может быть подключен сразу, но Вы сможете подключить его отдельно после создания кейса.</p>
                                    </div>
                                </template>
                            </template>
                        </template>
                        <template v-else>
                            <p>У Вас уже подключены все необходимые функции для создания кейса. Просто нажмите кнопку <strong>Создать кейс</strong>.</p>
                        </template>
                    </template>
                    <template v-if="check_projects == 2">
                        <p>К сожалению, на одном аккаунте можно создать до 10 приложений. В связи с этим, создание нового кейса на данный момент невозможно. На одном аккаунте можно добавить до 10 приложений. Удалите ненужные приложения в разделе <a href="/projects" target="_blank">Приложения</a> или зарегистрируйте новый аккаунт для новых приложений.</p>
                    </template>
                </div>
                <div v-else>
                    <p>Чтобы продолжить <a href="/login" target="_blank">авторизуйтесь</a> или <a href="/register" target="_blank">зарегистрируйтесь</a>, если у Вас еще нет аккаунта на сайте. После этого вернитесь на эту страницу.</p>
                </div>
                <button @click="stepBack3" class="btn btn-default border me-2">Назад</button>
                <button v-if="auth == 1 && check_projects == 1 && (!price || (price > 0 && check_balance == 1) || trial)" @click="createCase" class="btn btn-success">Создать кейс</button>
            </div>
            <div v-if="step == 4">
                <p>Кейс создается. Это займет какое-то время...</p>
            </div>
        </div>
    </div>
</template>
<style scoped>
    .case-item{
        background: #fff;
        border: 1px solid #e4e4e4;
        margin-bottom:10px;
    }
    .case-item.active{
        border-color: #fff;
    }
</style>
<script>
    export default {
        props: ['auth'],
        data(){
            return {
                name: "",
                errors: [],
                pro: 0,
                step: 1,
                type: 0,
                check_projects: 0,
                check_services: 0,
                check_balance: 0,
                check_trial: 0,
                add_balance_amount: 0,
                add_balance_in_process: 0,
                price: 0,
                test: 0,
                visible: false,
                img_index: 0,
                trial: 0,
                cases: {
                    type_1: {
                        name: 'Интернет-магазин', 
                        example: {
                            name: 'Магазин техники',
                            android: 'app2CFlLsBm3f',
                            ios: 1
                        },
                        blocks: [1],
                        price: 4990,
                        step_pro: 0,
                        imgs: [
                            '/img/cases/1_1.png',
                            '/img/cases/1_2.png',
                            '/img/cases/1_3.png',
                        ]
                    },
                    type_2: {
                        name: 'Доставка еды',  
                        example: {
                            name: 'Доставка еды',
                            android: 'appCbtEgUvNv0',
                            ios: 2
                        }, 
                        blocks: [1],
                        price: 4990,
                        step_pro: 0,
                        imgs: [
                            '/img/cases/2_1.png',
                            '/img/cases/2_2.png',
                            '/img/cases/2_3.png',
                        ]
                    },
                    type_3: {
                        name: 'Маникюр',   
                        example: {
                            name: 'Ваш Мастер Маникюра',
                            android: 'apphl7Dind224',
                            ios: 7
                        },
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/15_1.png',
                            '/img/cases/15_2.png',
                            '/img/cases/15_3.png',
                        ]
                    },
                    type_4: {
                        name: 'Ремонт квартир',  
                        example: {
                            name: 'Ремонт квартир',
                            android: 'app6nRdQE3jFw',
                            ios: 6
                        }, 
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/16_1.png',
                            '/img/cases/16_2.png',
                            '/img/cases/16_3.png',
                        ]
                    },
                    type_5: {
                        name: 'Салон красоты',   
                        example: {
                            name: 'Салон красоты Мария',
                            android: 'appUGqhtKRSPr',
                            ios: 5
                        },
                        blocks: [2,3],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/4_1.png',
                            '/img/cases/4_2.png',
                            '/img/cases/4_3.png',
                        ]
                    },
                    type_6: {
                        name: 'Мягкая мебель на заказ',   
                        example: {
                            name: 'Мягкая мебель',
                            android: 'appE11QtDJElA',
                            ios: 4
                        },
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/10_1.png',
                            '/img/cases/10_2.png',
                            '/img/cases/10_3.png',
                        ]
                    },
                    type_7: {
                        name: 'Кухни на заказ',   
                        example: {
                            name: 'Кухни на заказ',
                            android: 'appLGNNxNQR9M',
                            ios: 3
                        },
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/11_1.png',
                            '/img/cases/11_2.png',
                            '/img/cases/11_3.png',
                        ]
                    },
                    type_8: {
                        name: 'Другое', 
                        blocks: [2], 
                        price: 1990,
                        step_pro: 1,
                    },
                    type_9: {
                        name: 'Другое',
                        blocks: [2,3],
                        price: 1990,
                        step_pro: 1,
                    },
                    type_10: {
                        name: 'Стилист',   
                        example: {
                            name: 'Ваш Стилист Мария',
                            android: 'appYkKZBLjqB7',
                            ios: 16
                        },   
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/14_1.png',
                            '/img/cases/14_2.png',
                            '/img/cases/14_3.png',
                        ]
                    },
                    type_11: {
                        name: 'Компьютерный мастер',   
                        example: {
                            name: 'Компьютерный мастер',
                            android: 'appYpnHvYAWgJ',
                            ios: 17
                        }, 
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/17_1.png',
                            '/img/cases/17_2.png',
                            '/img/cases/17_3.png',
                        ]
                    },
                    type_12: {
                        name: 'Юридические услуги',   
                        example: {
                            name: 'Юридические услуги',
                            android: 'app5xT9AfSsp5',
                            ios: 18
                        }, 
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/18_1.png',
                            '/img/cases/18_2.png',
                            '/img/cases/18_3.png',
                        ]
                    },
                    type_13: {
                        name: 'Психотерапевт',   
                        example: {
                            name: 'Ваш психотерапевт',
                            android: 'applLuBcLYuLI',
                            ios: 19
                        }, 
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/19_1.png',
                            '/img/cases/19_2.png',
                            '/img/cases/19_3.png',
                        ]
                    },
                    type_14: {
                        name: 'Репетитор',   
                        example: {
                            name: 'Ваш Репетитор',
                            android: 'apphlifUgq9sR',
                            ios: 20
                        }, 
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/20_1.png',
                            '/img/cases/20_2.png',
                            '/img/cases/20_3.png',
                        ]
                    },
                    type_15: {
                        name: 'Массажист',    
                        example: {
                            name: 'Ваш Массажист',
                            android: 'apppEIAWJI1jF',
                            ios: 21
                        },   
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/21_1.png',
                            '/img/cases/21_2.png',
                            '/img/cases/21_3.png',
                        ]
                    },
                    type_16: {
                        name: 'Аниматор', 
                        example: {
                            name: 'NG4t5vkNzj',
                            android: 'apppEIAWJI1jF',
                            ios: 22
                        },     
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/22_1.png',
                            '/img/cases/22_2.png',
                            '/img/cases/22_3.png',
                        ]
                    },
                    type_17: {
                        name: 'Установка окон',  
                        example: {
                            name: 'Установка окон',
                            android: 'appluETytrfXG',
                            ios: 14
                        },   
                        blocks: [2],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/12_1.png',
                            '/img/cases/12_2.png',
                            '/img/cases/12_3.png',
                        ]
                    },
                    type_18: {
                        name: 'Организация мероприятий',   
                        example: {
                            name: 'Организация мероприятий',
                            android: 'app91BFow2Zv6',
                            ios: 15
                        },   
                        blocks: [2,3],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/13_1.png',
                            '/img/cases/13_2.png',
                            '/img/cases/13_3.png',
                        ]
                    },
                    type_19: {
                        name: 'Стоматология',  
                        example: {
                            name: 'Ваша Стоматология',
                            android: 'appsgdMkglwvF',
                            ios: 11
                        },  
                        blocks: [2,3],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/7_1.png',
                            '/img/cases/7_2.png',
                            '/img/cases/7_3.png',
                        ]
                    },
                    type_20: {
                        name: 'Ресторан',   
                        example: {
                            name: 'Ресторан Лучшая кухня',
                            android: 'appp109fXbbCq',
                            ios: 12
                        },  
                        blocks: [4],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/8_1.png',
                            '/img/cases/8_2.png',
                            '/img/cases/8_3.png',
                        ]
                    },
                    type_21: {
                        name: 'Автосервис',
                        example: {
                            name: 'Автосервис АвтоРем24',
                            android: 'appJZBnQ4xKoM',
                            ios: 13
                        },  
                        blocks: [2,3],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/9_1.png',
                            '/img/cases/9_2.png',
                            '/img/cases/9_3.png',
                        ]
                    },
                    type_22: {
                        example: {
                            name: 'Клиника Здоровье',
                            android: 'appEyYKlrCncV',
                            ios: 10
                        },
                        name: 'Клиника',
                        blocks: [2,3],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/6_1.png',
                            '/img/cases/6_2.png',
                            '/img/cases/6_3.png',
                        ]
                    },
                    type_23: {
                        name: 'Магазин одежды',
                        example: {
                            name: 'Магазин одежды',
                            android: 'app28endASyvs',
                            ios: 9
                        }, 
                        blocks: [1],
                        price: 4990,
                        step_pro: 0,
                        imgs: [
                            '/img/cases/3_1.png',
                            '/img/cases/3_2.png',
                            '/img/cases/3_3.png',
                        ]
                    },
                    type_24: {
                        name: 'Отель', 
                        example: {
                            name: 'Отель Best Hotel',
                            android: 'appvDOJpuIuRp',
                            ios: 8
                        },   
                        blocks: [5],
                        price: 1990,
                        step_pro: 1,
                        imgs: [
                            '/img/cases/5_1.png',
                            '/img/cases/5_2.png',
                            '/img/cases/5_3.png',
                        ]
                    },
                },
            }
        },
        methods: {
            async step1()
            {
                this.errors = [];

                if (!this.name) {
                    this.errors.push('Название кейса обязательно.');
                }
                else
                {
                    localStorage.name = this.name;
                    localStorage.type = this.type;
                    this.check_projects = 0;
                    if(this.auth == 1) await this.checkProjects();
                    if(!this.cases['type_' + this.type].step_pro){
                        if(this.auth == 1) await this.getPrice();
                        if(this.auth == 1) await this.checkBalance();
                        if(this.auth == 1) await this.checkTrial();
                        this.step = 3;
                    }
                    else
                    {
                        this.step = 2;
                    }
                }
            },
            async step2()
            {
                await this.getPrice();
                await this.checkBalance();
                await this.checkTrial();
                this.step = 3;
            },
            async stepBack3()
            {
                this.step = !this.cases['type_' + this.type].step_pro ? 1 : 2;
                this.add_balance_in_process = 0;
            },
            async createCase()
            {
                this.step++;
                await axios.post('/api/create_case', {type: this.type, name: this.name, pro: this.pro, trial: this.trial}).then(response => {
                    if(response.data && response.data > 0)
                    {
                        localStorage.name = '';
                        localStorage.type = 0;
                        window.location = '/cases/' + response.data;
                    }
                    else
                    {
                        this.step2();
                    }
                });
            },
            async checkProjects()
            {
                await axios.post('/api/check_projects').then(response => {
                    this.check_projects = response.data;
                });
            },
            async checkServices()
            {
                await axios.post('/api/check_services', {type: this.type}).then(response => {
                    this.check_services = response.data;
                });
            },
            async checkBalance()
            {
                await axios.post('/api/check_balance', {price: this.price}).then(response => {
                    this.check_balance = response.data;
                });
            },
            async checkTrial()
            {
                await axios.post('/api/check_trial', {type: this.type}).then(response => {
                    this.check_trial = response.data;
                });
            },
            async getPrice()
            {
                this.price = 0;
                await this.checkServices();
                if(this.check_services == 2 || this.check_services == 3)
                {
                    this.price += this.cases['type_' + this.type].price;
                }
                if(this.pro)
                {
                    this.price += 390;
                }
                this.add_balance_amount = this.price;
            },
            async add_balance()
            {
                this.add_balance_in_process = 1;
                var order_id = Math.floor(Math.random() * 1000000);
                var options = {
                    account: 60712190,
                    amount: this.add_balance_amount,
                    transactionId: order_id,
                    description: "Пополнение баланса в сервисе GiveMeApp"
                };

                var assistant = new Assistant.Builder();
                
                assistant.setOnSuccessCallback(async (operationId, transactionId) => {
                    setTimeout(() => 
                        {
                            $.post('/payment/success', {operationId: operationId, transactionId: transactionId, amount: this.add_balance_amount}).done(async () => {
                                await this.checkBalance();
                                this.add_balance_in_process = 2;
                                this.add_balance_amount = this.price;
                                //location.replace("{{ route('balance') }}");
                            });
                        },
                        Math.floor(Math.random() * 1000)
                    );
                })
                
                assistant.setOnFailCallback(async (operationId, transactionId) => {
                    setTimeout(() => 
                        {
                            $.post('/payment/fail', {operationId: operationId, transactionId: transactionId, amount: this.add_balance_amount}).done(async () => {
                                await this.checkBalance();
                                this.add_balance_in_process = 0;
                                this.add_balance_amount = this.price;
                                //location.replace("{{ route('balance') }}");
                            });
                        },
                        Math.floor(Math.random() * 1000)
                    );
                });
                
                assistant.setOnInProgressCallback(async (operationId, transactionId) => {
                    setTimeout(() => 
                        {
                            $.post('/payment', {operationId: operationId, transactionId: transactionId, amount: this.add_balance_amount});
                        },
                        Math.floor(Math.random() * 1000)
                    );
                });
                
                assistant.build(options, 'payment-form');
            },
            showImg (img_index) {
                this.img_index = img_index
                this.visible = true
            },
            handleHide () {
                this.visible = false
            }
        },
        watch: {
            type: async function () {
                if(this.auth == 1) await this.checkServices();
                if(this.auth == 1) await this.checkTrial();
            },
        },
        async mounted() {
            if(localStorage.name && localStorage.type)
            {
                this.name = localStorage.name;
                this.type = localStorage.type;
                if(this.auth == 1) await this.checkProjects();
                if(!this.cases['type_' + this.type].step_pro){
                    if(this.auth == 1) await this.getPrice();
                    if(this.auth == 1) await this.checkBalance();
                    if(this.auth == 1) await this.checkTrial();
                    this.step = 3;
                }
                else
                {
                    if(this.auth == 1) await this.checkTrial();
                    this.step = 2;
                }
            }
        }
    }
</script>
